import styled, { css } from 'styled-components';
import Modal from '../../../modal/index.js';
import { themeGet } from '../../foundation/theme/themeGet/get.js';

function getPositionCSS(position) {
  if (position === 'right') {
    return css(["margin-left:auto;"]);
  }
  return undefined;
}
function getTransitionCSS(state, position) {
  var endPosition = position === 'left' ? '-100%' : '100%';
  switch (state) {
    case 'visible':
      return css(["transform:translate(0,0);"]);
    case 'entering':
    case 'leaving':
    case 'hidden':
      return css(["transform:translate(", ",0);"], endPosition);
    default:
      return undefined;
  }
}
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-mv5jfe-0"
})(["height:100%;overflow:hidden;overflow-y:auto;transition:transform 0.2s ease-in-out;transition-delay:5ms;box-shadow:", ";", " ", ""], themeGet('dropShadow.300'), function (props) {
  return getPositionCSS(props.$position);
}, function (props) {
  return getTransitionCSS(props.$state, props.$position);
});
var StyledModal = styled(Modal).withConfig({
  displayName: "StyledModal",
  componentId: "sc-mv5jfe-1"
})(["background-color:transparent;"]);

export { Container, StyledModal };
